import { ChangeDetectorRef, Component } from '@angular/core';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable, combineLatest } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { map, take } from 'rxjs/operators';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-clinical-fluad-first',
    templateUrl: './clinical-fluad-first.component.html',
    styleUrls: ['./clinical-fluad-first.component.scss'],
    standalone: false
})
export class ClinicalFluadFirstComponent {
  constructor(private accessService: ContentService, public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, private cd: ChangeDetectorRef,private userInfoService: UserInfoService) { }
  firstheadline: Observable<any> = this.bannerComponent.data$;
  mergedObject1: any = [];
  userLoggedIn: boolean = false;
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }

  ngOnInit() {
    this.firstheadline.pipe(take(1)).subscribe(res => {
      this.clinicaltabs(res);
    });
    this.userInfoService.userLoggedIn$.subscribe(res=>{
    
      this.userLoggedIn = res;
      // if(this.userLoggedIn == true){
      //   this.renderer.setStyle(document.querySelector('.SideContent'),'display','block');
      // }
    })
  }

  clinicaltabs(res: any) {
    // const tilesList = res.boostedNavList.split(" ");
    // const observables = tilesList.map((el: any) => this.accessService.opeffeaturedResources(el));

    // combineLatest(observables).pipe(
    //   map((results:any) => results.flat())
    // ).subscribe((mergedResults: any) => {
    //   this.mergedObject1 = mergedResults;
    //   this.cd.detectChanges();
  
    // });
    const tilesList = res.boostedNavList.split(" ");
    this.accessService.opeffeaturedResources(tilesList).subscribe((res : any) => {
     this.mergedObject1 = res.component;

     this.cd.detectChanges;
    });
  }
  gettabsImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }
  gettabsMobileImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.tablet.url;
  }
}